module.exports = __webpack_public_path__ + "img/1x.d3510f2.jpg";